import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 152px);
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-family: ${theme.font.comfortaa};
    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.normal};
    margin: 14px 8px -72px 90px;
    width: 100%;
    max-width: 1084px;

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 460px;
    `}

    ${media.lessThan('small')`
      max-width: 270px;
    `}
  `}
`

export const Body = styled.div`
  ${({ theme }) => css`
    padding: 24px 24px 0 12px;
    > button {
      max-width: 328px;
      position: relative;

      > svg {
        position: absolute;
        left: 16px;
        top: 14px;

        > path {
          fill: ${theme.colors.white};
        }
      }
    }
    width: 100%;
    position: relative;
    max-width: 1084px;
    height: auto;
    margin: 82px 8px 40px 90px;
    background: ${theme.colors.white};
    border-radius: ${theme.border.radius};

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 580px;
    `}

    ${media.lessThan('small')`
      max-width: 300px;
    `}
    .active-checkbox {
      width: 20%;
      position: relative;
      margin-left: 77%;
      margin-top: 2%;
      flex-direction: row-reverse;
      Label {
        color: ${theme.colors.primary};
        width: 35%;
      }
    }
  `}
`
export const InputsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  .create-test-inputs {
    padding: 2.5% 2% 2.5% 2%;
  }
`
export const CreateTitle = styled.div`
  ${({ theme }) => css`
    border-bottom: solid;
    border-color: ${theme.colors.primary};
    font-size: ${theme.font.sizes.medium};
    color: ${theme.colors.primary};
    display: flex;
    padding: 24px 24px 0 12px;
    > button {
      max-width: 228px;
      position: relative;
      left: 57%;
      margin-bottom: 0.5%;

      > svg {
        position: absolute;
        left: 16px;
        top: 14px;

        > path {
          fill: ${theme.colors.white};
        }
      }
    }
  `}
`
export const TableContainer = styled.div`
  padding: 24px;

  ${media.lessThan('medium')`
    padding: 24px 50px;
  `}
`

export const ModalInfo = styled.div`
  > button {
    margin-top: 28px;
  }
`
